import React from "react";
import PropTypes from "prop-types";
import Alert from "components/alert-view";
import { defineMessages, FormattedMessage } from "react-intl";
import appconfig from "config/appconfig";
import { Typography } from "@getgo/chameleon-web-react-wrapper";
import { PasskeyOutlinedIcon } from "@getgo/chameleon-icons/react";
import classes from "./alert.scss";

const t = defineMessages({
  "alert.passkey-signin.description": {
    id: "alert.passkey-signin.description",
    defaultMessage: "Use a passkey to access GoTo in a more convenient and secure way. <a>Learn more</a>",
  },
});

export const AlertPasskeyView = ({ handleDismiss }) => (
  <Alert
    type={appconfig.alertTypes.WARNING}
    icon={<PasskeyOutlinedIcon />}
    body={
      <span className={classes.bannerMessageText}>
        <Typography>
          <FormattedMessage
            {...t["alert.passkey-signin.description"]}
            values={{
              a: (chunks) => ( <a className="learnMoreLink" href="https://link.goto.com/sign-in" rel="noopener noreferrer" target="_blank">{chunks}</a>)
            }} />
        </Typography>
      </span>
    }
    handleDismiss={handleDismiss}
  />
);

AlertPasskeyView.propTypes = {
  alertVisisble: PropTypes.bool.isRequired,
  handleDismiss: PropTypes.func.isRequired
};

export default AlertPasskeyView;
